var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4147 16.6926H13.5999V12.2852C13.5999 11.2333 13.5777 9.88148 12.1332 9.88148C10.6666 9.88148 10.4406 11.0259 10.4406 12.2074V16.6926H7.62583V7.62593H10.3295V8.86296H10.3666C10.7443 8.15185 11.6629 7.4 13.0332 7.4C15.8851 7.4 16.411 9.27778 16.411 11.7185L16.4147 16.6926ZM4.45176 6.38518C3.54435 6.38518 2.81842 5.65185 2.81842 4.75185C2.81842 3.85185 3.54805 3.11852 4.45176 3.11852C5.35546 3.11852 6.08509 3.85185 6.08509 4.75185C6.08509 5.65185 5.35176 6.38518 4.45176 6.38518ZM5.86287 16.6926H3.04064V7.62593H5.86287V16.6926ZM17.8221 0.5H1.62953C0.855459 0.5 0.22583 1.11111 0.22583 1.87037V18.1296C0.22583 18.8852 0.851756 19.5 1.62953 19.5H17.8184C18.5925 19.5 19.2258 18.8889 19.2258 18.1296V1.87037C19.2258 1.11111 18.5925 0.5 17.8221 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f65b38da2d65ebf63dc7d3c28a4fdbae.svg";
export { ForwardRef as ReactComponent };